export default "__VITE_ASSET__t$JhOs0e__"